<template>
  <!-- String or Number -->
  <template v-if="dataType === 'string' || dataType === 'number'">
    <highlight-region
      v-if="filter && filter.length > 0"
      :text="typeof data === 'string' ? data.toString() : ''"
      :filter="filter"
      :word-wrap="wordWrap"
    ></highlight-region>
    <template v-else>
      {{ data?.toString() }}
    </template>
  </template>
  <!-- Time -->
  <template v-if="dataType === 'time'">
    <highlight-region
      v-if="filter && filter.length > 0"
      :text="renderTime(data)"
      :filter="filter"
      :word-wrap="wordWrap"
    ></highlight-region>
    <template v-else>
      {{ renderTime(data) }}
    </template>
  </template>
  <!-- Booleans -->
  <template v-if="dataType === 'boolean'">
    <i v-if="renderBoolean(data)" class="las la-check"></i>
  </template>
  <!-- Date -->
  <template v-if="dataType === 'date'">
    {{ renderDate(data) }}
  </template>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import HighlightRegion from 'components/TableCellHighlightSearch.vue'
//TODO: Change location of common types related to table.
import { SortingKeyType } from 'composables/sortAlgorithm'

export default defineComponent({
  props: {
    data: {
      type: String,
      required: true,
    },
    dataType: {
      type: [String, null] as PropType<SortingKeyType>,
      required: true,
    },
    filter: {
      required: false,
      type: String as PropType<string | null>,
      default: null,
    },
    wordWrap: {
      required: false,
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  components: { HighlightRegion },
  setup() {
    //Sorting key type "string" | "number" | "boolean" | "date" | "time" | null
    //take dataType and data, call appropriate fn on data type
    //return appropriate value or render based on dataType

    //time should return minutes in a specificed format
    // e.g. 6 mins or 1 hr 30 mins or 1h 30m
    const renderTime = (duration: string): string => {
      //duration in minutes
      const hours = Math.floor(+duration / 60)
      const minutes = +duration % 60

      if (hours > 0) {
        return `${hours}h ${minutes}m`
      }
      return `${minutes}m`
    }
    //date should render a specific way
    const renderDate = (value: Date | string | null | undefined) => {
      if (typeof value === 'undefined' || value === null || value === '') return ''
      else if (Object.prototype.toString.call(value) === '[object Date]') {
        if (!value) {
          return null
        }
        // reformat dates to MM/DD/YYYY
        return `
        ${(value as Date).getMonth() + 1}/${(value as Date).getDate()}/${(
          value as Date
        ).getFullYear()}
        `
      } else {
        return `
        ${new Date(value).getMonth() + 1}/${new Date(value).getDate()}/${new Date(
          value
        ).getFullYear()}
        `
      }
    }
    //values should pass as true or not
    const renderBoolean = (value: string | boolean): boolean => {
      if (typeof value === 'boolean') {
        return value
      } else {
        if (value.toUpperCase() == 'T') return true
        if (value.toUpperCase() == 'TRUE') return true
        return value.toUpperCase() === 'YES' ? true : false
      }
    }

    return { renderBoolean, renderTime, renderDate }
  },
})
</script>
